/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect } from 'react';

import { Locale, LocaleKeys } from '../../../../core/locale';
import { KeyManager } from '../../../../core/navigation';
import { SettingsTemplate } from '../../SettingsTemplate';

import '../../SettingsCommon.scss';

const SettingParentalLocks: FunctionComponent = () => {
    const text = Locale.getString(LocaleKeys.SETTINGS_HELP_PC_SETTINGS_LOCK_LIMITS);

    useEffect(() => {
        const keyManagerIns: KeyManager = KeyManager.getInstance();
        if (keyManagerIns.isKeyIgnoring()) {
            keyManagerIns.stopKeyIgnoring();
        }
    }, []);

    return (
        <SettingsTemplate title={Locale.getString(LocaleKeys.PC_HELP_SCREEN_SETTINGS_TITLE)}>
            <div className="settings-common-content text-content">{text}</div>
        </SettingsTemplate>
    );
};

export default SettingParentalLocks;
